<template>
  <div>
    <div class="text-center mt-10 mb-10">
      <h5 class="mt-10 mb-20 font-web">เลือก <strong class="text-danger">ทะเบียนรถ</strong> ที่ต้องการลงทะเบียนที่จอด</h5>
      <a-radio-group button-style="solid">
        <a-radio-button v-for="item in listcar" :key="'no'+item.id" :value="item.id">
          {{ item.name }}
          {{ item.vehicleNumber }}
        </a-radio-button>
      </a-radio-group>
    </div>

    <div align="center" class="mt-30 mb-20">
      <a-card :bordered="false" hoverable style="width: 450px;height: 500px">
        <a-card-meta>
          <template slot="title">
            <img
              style="height: 95px; width: 100%;"
              alt="imag_formpay_1"
              src="/images/qrHeader.png"
            />

          </template>
          <template slot="description">
            

            <!-- loading Gen -->
            <img
              class="mt-10"
              style="height: 150px; width: 150px;"
              alt="imag_formpay_2"
              src="/images/cuteload.gif"
            />

            <a-list class="demo-loadmore-list" item-layout="horizontal">
                <!-- app name -->
                <a-list-item>
                  <div>Detail</div>
                  <div>
                    <p class="mt-0 mb-0">Ref 1 : xxxxx</p>
                    <p class="mt-0 mb-0">Ref 2 : xxxxx</p>
                  </div>
                </a-list-item>
                <a-list-item>
                  <div>Expirse</div>
                  <div>
                    {{ moment().format("DD/MM/YYYY") }}
                  </div>
                </a-list-item>
                <a-list-item>
                  <div>Amount</div>
                  <div>
                    4,000 Baht
                  </div>
                </a-list-item>
            </a-list>

          </template>
        </a-card-meta>
    
    
  </a-card>
    </div>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      listcar: [
        {
           id: 1,
           status: "car",
           name: "Honda",
           vehicleNumber: "กก1234",
           GasType: "Gasoline",
        },
        {
           id: 2,
           status: "car",
           name: "Honda",
           vehicleNumber: "กก1234",
           GasType: "Gasoline",
        },
        {
           id: 3,
           status: "car",
           name: "Honda",
           vehicleNumber: "กก1234",
           GasType: "Gasoline",
        },
      ],
    };
  },
  mounted() { },
  methods: {},
};
</script>

<style scoped></style>